import React from 'react';
import { useSelector } from 'react-redux';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { t } from '../../../helpers/t';
import { projectTypeIconMap } from '../../../helpers/fontAwesome.js'

export function ListingIdealUses() {
  const { _meta } = useSelector((state) => state.listing);

  return (
    <div className="px-4 md:px-0 py-6">
      <h2 id="ideal_uses" className="text-stone-900 text-2xl font-semibold mb-4">
        {t('listings.show.sections.project_types.header')}
      </h2>
      <div className="grid grid-cols-2 gap-x-3 gap-y-3 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5">
        {
          _meta.projectTypes.map((projectType, index) => {
            const icon = projectType.parent.icon ? `${projectType.parent.icon}` : '';

            return (
              <div key={`listing-project-type-${index}`} className="border-0 border-l-3 border-b border-solid border-stone-200 flex flex-col items-start rounded-lg py-3 px-3 bg-stone-50 justify-center hover:bg-stone-100 hover:border-stone-300 hover:shadow-sm transition-all duration-200">
                <div className="font-light parent-project-type text-sm text-stone-900 flex items-center justify-start w-full">
                  {projectTypeIconMap[icon] && (
                    <div className="w-5 mr-3 flex items-center justify-center flex-shrink-0">
                      <FontAwesomeIcon icon={projectTypeIconMap[icon]} className="text-lg text-stone-700" aria-hidden />
                    </div>
                  )}
                  <span className="text-left leading-relaxed">{projectType.parent.name}</span>
                </div>
              </div>
            );
          })
        }
      </div>
    </div>
  );
}
